import React, { Component } from 'react';
import { View, ActivityIndicator, StyleSheet } from 'react-native';
import Theme from '../../theme';
import Pdf from 'react-native-pdf';
import { showError } from '../../ui';

export class BodyScanReport extends Component {
  render() {
    const { t, scanDate, error, isLoading, pdf } = this.props;

    if (isLoading) {
      return (
        <View style={styles.loadingContainer}>
          <ActivityIndicator
            size="small"
            color={Theme.PRIMARY}
            animating={isLoading}
          />
        </View>
      )
    }

    if (error) {
      showError(t('errorNoReport'));
    }

    if (!pdf) {
      return null;
    }

    return (
      <Pdf source={{ uri: `data:application/pdf;base64,` + pdf }} scanDate={scanDate} />
    )
  }
}

const styles = StyleSheet.create({
  loadingContainer: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: 100,
    alignItems: 'center',
    justifyContent: 'center'
  },
});
